import client from './AxiosClient'

const orderService = {
    getAll : (params) => client.get("/orders/filter", { params }),
    updateStatus : (data) => client.put(`/enquiry/update-status`,data),
    getDetail : (orderId) => client.get(`/orders/detail?orderId=${orderId}`),
}

export default orderService;